import { registerLocale } from 'react-datepicker';
import { ja, enUS } from 'date-fns/locale';

export default () => {
  registerLocale('ja', ja);
  registerLocale('en', enUS);
};
